module.exports = __webpack_public_path__ + "static/media/prawdziwa-przyjazn.86f2d6df.jpg";